var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('EstadoMaquinaCazels',_vm._g(_vm._b({attrs:{"value":_vm.visible,"poll-ms":_vm.pollMs}},'EstadoMaquinaCazels',_vm.$attrs,false),_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }